
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize px-3 pt-3 font-weight-bold">
            {{ $tc('pages.documents')}}
          </span>
        </template>

        <template v-slot:content>
          <document-list class="mt-n5" :company_id="company_id" :project_id="project_id" :model_used="model_used"></document-list>
        </template>

      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DocumentList from './DocumentList.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'DialogDocumentList',
  //mixins: [ validations ],
  props: {
    model_used: { // project, company
      type: String, 
    },
    company_id: {
      type: [String, Number]
    },
    project_id: {
      type: [String, Number]
    }
  },
  components: {
    DocumentList
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>